const sidebar = {
    bindings: {},
    templateUrl: '/modules/common/sidebar/sidebar-container/sidebar-container.html',
    controller: 'SidebarContainerController',
    transclude: true,
};

angular
    .module('sidebar.module')
    .component('sidebarContainer', sidebar);